import { useState, useEffect } from "react";
import { Play, Headset } from "lucide-react";
import TestRequestFormWithCountries from "@/components/TestRequestFormWithCountries";
import ChatbotSAV from "@/components/ChatbotSAV";
import { useIsMobile } from "@/hooks/use-mobile";

const FloatingTestCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Desktop: CTA test gratuit + chatbot classique avec texte
  if (!isMobile) {
    return (
      <>
        <div
          className={`fixed bottom-20 right-5 z-50 transition-all duration-300 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
          }`}
        >
          <TestRequestFormWithCountries
            trigger={
              <button
                className="relative px-4 py-3 min-h-[48px] rounded-full flex items-center gap-2 shadow-lg bg-secondary hover:bg-secondary/90 hover:scale-105 transition-all duration-300"
                aria-label="Essayer IPTV gratuitement pendant 24h"
              >
                <Play className="w-4 h-4 text-secondary-foreground fill-current" />
                <span className="text-secondary-foreground font-semibold text-sm whitespace-nowrap">
                  Essayez 24h GRATUIT
                </span>
                <span className="absolute -top-3 -right-3 bg-primary text-primary-foreground text-[11px] font-bold px-2 py-0.5 rounded-full shadow-md">
                  Seulement 10/jour
                </span>
              </button>
            }
          />
        </div>
        <ChatbotSAV />
      </>
    );
  }

  // Mobile: widget compact unifié
  return (
    <div
      className={`fixed bottom-5 right-3 z-50 flex items-center gap-1.5 transition-all duration-300 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <TestRequestFormWithCountries
        trigger={
          <button
            className="relative px-3 py-2.5 min-h-[44px] rounded-full flex items-center gap-1.5 shadow-lg bg-secondary hover:bg-secondary/90 hover:scale-105 transition-all duration-300"
            aria-label="Essayer IPTV gratuitement pendant 24h"
          >
            <Play className="w-3.5 h-3.5 text-secondary-foreground fill-current" />
            <span className="text-secondary-foreground font-semibold text-xs whitespace-nowrap">
              Essayez 24h GRATUIT
            </span>
            <span className="absolute -top-2.5 -right-2 bg-primary text-primary-foreground text-[10px] font-bold px-2 py-0.5 rounded-full shadow-md">
              Seulement 10/jour
            </span>
          </button>
        }
      />

      <ChatbotSAV
        trigger={
          <button
            className="w-11 h-11 rounded-full flex items-center justify-center shadow-lg bg-primary hover:bg-primary/90 hover:scale-110 transition-all duration-300 relative"
            aria-label="Contacter le support 24/7"
          >
            <Headset className="w-5 h-5 text-primary-foreground" />
            <span className="absolute -top-1 -right-1 text-[8px] font-bold bg-secondary text-secondary-foreground rounded-full px-1 py-0.5 leading-none">
              24/7
            </span>
          </button>
        }
      />
    </div>
  );
};

export default FloatingTestCTA;
